import React from "react";

const newline = "\n";

export function nl2br(text) {
  if (typeof text === "number") {
    return text;
  } else if (typeof text !== "string") {
    return "";
  }

  const lines = text.split(newline);

  if (lines.length === 1) {
    return text;
  }

  return lines.map((line, i) => {
    return (
      <span key={i}>
        {line}
        {i !== lines.length - 1 && <br />}
      </span>
    );
  });
}
